import { useMemo } from "react";
import { useTheme } from "styled-components";
import Library from "react-content-shimmer";
import { ShimmerProps } from "./types";

function Shimmer({
  background = "dark400",
  foreground = "dark600",
  height = 18,
  speed = 4,
  purpose,
  width = "100%",
}: ShimmerProps) {
  const theme = useTheme();
  const commons = useMemo(
    () => ({
      rows: 1,
      background: theme.colors[background],
      foreground: theme.colors[foreground],
      speed,
      rounded: "4px",
      elevation: 0,
      style: { boxShadow: "none", width },
    }),
    [background, foreground, speed, theme, width],
  );

  if (purpose === "card") {
    return <Library {...commons} rounded={"12px"} size={{ height, width }} />;
  }

  if (purpose === "value") {
    return <Library {...commons} size={{ height, width }} />;
  }

  if (purpose === "circle-small") {
    return (
      <Library {...commons} rounded={"100%"} size={{ height, width: height }} />
    );
  }

  return <Library />;
}

export default Shimmer;
